import { Observable } from 'rxjs';
import { split, ref, getValues } from '@dbk-legacy/muster/utils';
import muster from '@dbk-legacy/muster';
import { sortable, variable, redirectOn } from '@dbk-legacy/muster/helpers';
import { Alert } from 'react-native';
import map from 'lodash/fp/map';
import { VASCO_API_RESPONSE, VASCO_API_ERROR_CODES, VASCO_FLOW, VASCO_MODAL_TYPES, VASCO_ERROR_MESSAGES, APIRESPONSECODES, ROUTES, OTP_INTERVAL} from '../constants';
let COUNTDOWN_ID = 0;

export default () =>
  muster()
    .path('vascoauthentication.validateVascoPwd', {
      call: async ({ req }, { get, set, call }) => {
        const oneTimePassword = "S" + req.args[0];
        const deviceCode = 'BROWSER';
        const [ran_str] = await getValues(get('vascoauthentication.varifyOtpRandomNumber'));
        const [oReturn] = await getValues(get(`roster.data.vascoauthentication.verifyOTP.["${ran_str}"].["${deviceCode}"].["${oneTimePassword}"]`));
        const oResult = JSON.parse(oReturn);
        const [regionCode] = await getValues(get(['config.regionCode']));
        if (oReturn.$type && oReturn.$type.toLowerCase() == VASCO_API_RESPONSE.error) {
          await set('vascoauthentication.vascoAuthorised', { type: 'error', errorMsg: oReturn.errorMsg || oReturn.value.message });
          return;
        }
        if (oResult.retCode === VASCO_API_ERROR_CODES.invalidSession) {
          await set('vascoauthentication.vascoAuthorised', false);
          await set('vascoauthentication.otpStatus', false);
          await set('vascoauthentication.statusCode', oResult.retCode);
          return;
        }

        if (oResult.returnCode === VASCO_API_ERROR_CODES.SUCCESS &&
          oResult.data.toUpperCase() === VASCO_API_RESPONSE.success) {
          // Verify OTP check for E-Credentials: Password Reset
          const [verifyOTPForECredPwd] = await getValues(get('forgotPassword.verifyOTPForForgotPassword'));
          if (verifyOTPForECredPwd) {
            await set('forgotPassword.verifyOTPForForgotPasswordSuccess', true);
            await set('vascoauthentication.vascoVisible', false);
            await set('auth.authHeader', oResult.jwt);
            return;
          }
          const [isAISConfirm] = await getValues(get('ais.isConfirmed'));
          const [isAISReject] = await getValues(get('ais.isRejected'));

          //await set('pis.isPaymentOtpVerified', true);

          if(isAISConfirm || isAISReject){
            await set('auth.authHeader', oResult.jwt);
            await set('ais.isAccountOtpVerified', true);
            return;
          }
          
          await set('vascoauthentication.vascoAuthorised', true);

          const [pisFlowConfirmationStatus] = await getValues(get(['pis.isPaymentExecute']));
          
          const [vascoPageName] = await getValues(get('ui.state.rsaPageName'));
          // WMCE-406 changes for ch region only
          if (regionCode === "CH") {
            await set('vascoauthentication.otpStatus', true);
            await call('vascoauthentication.hideVasco');
            await set('auth.authHeader', oResult.jwt);
            await set('auth.dashboardAuthorised', true);

            if(pisFlowConfirmationStatus != null) {
              await set('pis.isPaymentOtpVerified', true);
              await call('ui.history.push', { pathname: ROUTES.PAYMENT.PSD2_PIS});
              return;
            } else {
              // when vascoPageName is /terms-condition then only replace path in history stack
              if (vascoPageName) {
                call('ui.history.replace', { pathname: vascoPageName });
              }
              else {
                call('ui.history.push', { pathname: '/loadportfolio' });
                await set('auth.loadportfoliosrc', true);
              }
  
                
              
              await call('auth.getDashboardContent');

            }
            
            
          }

            else {
              await set('auth.authorised', true);
              await set('auth.authHeader', oResult.jwt);
              await set('auth.dashboardAuthorised', true);
              await call('auth.getDashboardContent');
              await set('vascoauthentication.otpStatus', true);
              call('ui.history.push', { pathname: vascoPageName });
              await call('vascoauthentication.hideVasco');
            }
          

          
          
        }

        else if (oResult.returnCode === VASCO_API_ERROR_CODES.otpIncorrect || oResult.returnCode === VASCO_API_ERROR_CODES.otpReplay) {
          if(oResult.returnCode === VASCO_API_ERROR_CODES.otpReplay){
            await call('vascoauthentication.startCountDownTimer');
          }else{
            await set('vascoauthentication.varifyOtpRandomNumber',  "random" + Math.round(Math.random() * 1000));
          }
          await set('vascoauthentication.vascoAuthorised', false);
          await set('vascoauthentication.otpStatus', false);
          await set('vascoauthentication.statusCode', oResult.returnCode);
        }
        else if (oResult.returnCode === VASCO_API_ERROR_CODES.userLocked || (oResult.returnCode === 0 && oResult.errorMsg === VASCO_ERROR_MESSAGES.otpVerificationErrorString)) {
          await set('vascoauthentication.otpStatus', false);
          await set('vascoauthentication.otpStatus', false);
          await set('vascoauthentication.vascoAuthorised', false);
          await set('vascoauthentication.statusCode', oResult.returnCode);
        }
        else {
          await set('vascoauthentication.vascoAuthorised', false);
          await set('vascoauthentication.otpStatus', false);
          await set('vascoauthentication.statusCode', oResult.returnCode);

        }
      },
    })
    .path('vascoauthenticaiton.hideNotActivatedModal', {
      call: async ({ req }, { get, set, call }) => {
        set('vascoauthentication.hideVascoActivatedFlag', false);
        await set('auth.vascoFlow', VASCO_FLOW.noVasco);
        await call('vascoauthentication.hideVasco');
        // const [pageName] = await getValues(get('ui.state.rsaPageName'));

        // call('ui.history.push', { pathname: pageName });
        // call('ui.history.replace', { pathname: pageName });

      },
    })
    .path('vascoauthentication.setOTPStatus', {
      call: async ({ req }, { get, set, call }) => {
        await set('vascoauthentication.otpStatus', req.args[0]);
      },
    })
    .path('vascoauthentication.setOTPStatuscode', {
      call: async ({ req }, { get, set, call }) => {
        await set('vascoauthentication.statusCode', req.args[0]);
      },
    })
    .path('vascoauthentication.vascoStatus', variable())
    .path('vascoauthentication.statusCode', variable())
    .path('vascoauthentication.hideVasco', {
      call: async ({ req }, { get, set, call }) => {

        // reset vasco authentication variables
        await set('vascoauthentication.otpStatus', undefined);
        await set('vascoauthentication.statusCode', undefined);
        await set('hrmw.isManageContactDetailsMcd', false);
        await set('ais.isAccountConfirmation', false);

        const [vascoVisible] = await getValues(get(['vascoauthentication.vascoVisible']));
        if (vascoVisible) await set('vascoauthentication.vascoVisible', false);

        const [authVascoFlow] = await getValues(get('auth.vascoFlow'));
        const [vascoAuthorised] = await getValues(get('vascoauthentication.vascoAuthorised'));
        if (authVascoFlow === VASCO_FLOW.resetPassword && !vascoAuthorised) {
          await set('auth.vascoFlow', undefined);
          await set('auth.authorised', false);
          await call('resetcode.resetVariables');
        }
      },
    })
    .path('vascoauthentication.updateActivationStatus', {
      call: async ({ req }, { get, set, call }) => {
        const deviceCode = 'BROWSER';// await getValues(get('device.uniqueId'));
        const [isNTB] = await getValues(get('vascoauthentication.isNTB'));
        const vascoStatus = req.args[0];
        const isRegistrationSkipped = req.args[1];
        const [oReturn] = await getValues(get(`roster.data.vascoauthentication.updateActivationStatus.["${deviceCode}"].["${isNTB}"].["${vascoStatus}"].["${isRegistrationSkipped}"]`));
        if (oReturn.$type && oReturn.$type.toLowerCase() == VASCO_API_RESPONSE.error) {
          await set('vascoauthentication.vascoAuthorised', { type: 'error', errorMsg: oReturn.errorMsg || oReturn.value.message });
          return;
        }
        const oResult = JSON.parse(oReturn);
        if (oResult.returnCode === -1) {
          await set('vascoauthentication.vascoAuthorised', { type: 'error', errorMsg: oReturn.errorMsg || oReturn.value.message });

        }
      },
    })
    .path('vascoauthentication.setVascoModalType', {
      call: async ({ req }, { get, set, call }) => {
        if (req.args[0]) {
          const modalType = req.args[0];
          const [vascoVisible] = await getValues(get(['vascoauthentication.vascoVisible']));
          if (!vascoVisible) await set('vascoauthentication.vascoVisible', true);
          await set('vascoauthentication.vascoModalType', modalType);
        }
      },
    })
    .path('vascoauthentication.isVascoModalVisible', variable())
    .path('vascoauthentication.deactivateSecondFactor', {
      call: async ({ req }, { get, set, call }) => {
        await set('vascoauthentication.deactivateSecondFactorResponse', null);
        await set('vascoauthentication.showSpinner', true);
        const deviceCode = req.args[0];
        const [oReturn] = await getValues(get(`roster.data.vascoauthentication.deactivateDevice.["${deviceCode}"]`));
        await set('vascoauthentication.showSpinner', false);
        if (oReturn.$type && oReturn.$type.toLowerCase() === VASCO_API_RESPONSE.error) {
          await set('vascoauthentication.deactivateSecondFactorResponse', { type: VASCO_API_RESPONSE.error, errorMsg: oReturn.errorMsg || oReturn.value.message });
          return;
        }
        const oResult = JSON.parse(oReturn);
        if (oResult.returnCode === APIRESPONSECODES.success) {
          await set('vascoauthentication.deactivateSecondFactorResponse', oResult);
          await call('vasco.fetchSecondFactorStatusDetails');
          return;
        }
        if (oResult.returnCode === APIRESPONSECODES.error) {
          await set('vascoauthentication.deactivateSecondFactorResponse', { type: VASCO_API_RESPONSE.error, errorMsg: oResult.errorMsg });
        }

      },
    })
    .path('vascoauthentication.deactivateSecondFactorResponse', variable())
    .path('vascoauthentication.vascoAuthorised', variable())
    .path('vascoauthentication.vascoVisible', variable())
    .path('vascoauthentication.vascoModalType', variable())
    .path('vascoauthentication.isNTB', variable(true))
    .path('vascoauthentication.gracePeriod', variable())
    .path('vascoauthentication.hideVascoActivatedFlag', variable())
    .path('vascoauthentication.otpStatus', variable())
    .path('pis.otpStatus', variable(false))
    .path('vascoauthentication.countDown', variable(null))
    .path('vascoauthentication.varifyOtpRandomNumber', variable( "random" + Math.round(Math.random() * 1000)))
    .path('vascoauthentication.startCountDownTimer', {
      call: async ({ req }, { get, set }) => {
        set('vascoauthentication.countDown', OTP_INTERVAL);
        COUNTDOWN_ID = setInterval(async () => {
          let [countDown] = await getValues(get(['vascoauthentication.countDown']));
          countDown = countDown - 1;
          if(countDown <= 0){
            countDown = null;
            clearInterval(COUNTDOWN_ID);
          }
          set('vascoauthentication.countDown', countDown);
        }, 1000);
      }
    })
    .path('vascoauthentication.twoFaRegisPendingCode', variable(null));
